export default "__VITE_ASSET__HtNkz1Rm__"